<template>
	<div class="site-section interior">
    <section class="hero is-medium is-black is-vcentered">
      <div class="columns is-tablet">
        <div class="column is-one-third is-one-quarter-tablet is-full-mobile">
          <img src="../../assets/hero-daddy-academy.png">
        </div>
        <div class="column">
          <div class="hero-body">
            <h1 class="is-size-1 lucky-title">
              Scholarship
            </h1>
            <div class="intro">We are focused on building our community's ability to build, learn, & play!</div>
          </div>
        </div>
      </div>
    </section>
    <section class="body-content">
      <p>Equal opportunity only exists through equal access to the tools necessary to build your dreams.</p>
      <p>At NFDaddys, we recognize the tools may be different for many folks and we want to accommodate to our fullest extent to provide our community the resources they require.</p>
      <p>If you are interested in having your project considered, please <a href="/team/contact">contact us</a> here.</p>
    </section>
	</div>
</template>
<script>
/* eslint-disable no-console */
export default {
  name: "Scholarship",
  methods: {

  },
};
/* eslint-enable no-console */
</script>
<style scoped>


</style>